import gql from 'graphql-tag'

export default gql`query inscriptionNewId {
  inscriptionNewId
}`
